import { lazy, Suspense, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AppShell } from '@p31ca/design-core/compositions'
import { Topbar } from './components/Topbar'
import { SidebarNav } from './components/SidebarNav'
import { MobileBottomNav } from './components/MobileBottomNav'
import { CalmOverlay } from './components/CalmOverlay'
import { initTheme } from './lib/theme'
import { useUI } from './lib/store'
import './playground.css'

/* The ambient instrument (dome + LED chip) — lazy, same pattern as the design
   portal: mounts after load so FCP/LCP lock onto the surface. */
const DomeBackground = lazy(() => import('./components/DomeBackground'))
const LedController = lazy(() => import('@p31ca/p31ca-ambient/LedController'))

const Home = lazy(() => import('./routes/Home'))
const Catalog = lazy(() => import('./routes/Catalog'))
const PackView = lazy(() => import('./routes/Pack'))
const Compose = lazy(() => import('./routes/Compose'))
const Playground = lazy(() => import('./routes/Playground'))
const Identity = lazy(() => import('./routes/Identity'))
const Activity = lazy(() => import('./routes/Activity'))
const Channels = lazy(() => import('./routes/Channels'))
const Schema = lazy(() => import('./routes/Schema'))
const ForgeChat = lazy(() => import('./routes/ForgeChat'))

export default function App() {
  const { world, mode, spoons } = useUI()

  useEffect(() => { initTheme() }, [])

  useEffect(() => {
    const root = document.documentElement
    root.dataset.world = world
    root.dataset.mode = mode
    root.dataset.capacity = spoons <= 1 ? 'low' : 'normal'
    root.dataset.theme = world
  }, [world, mode, spoons])

  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <DomeBackground />
        <LedController />
      </Suspense>
      <AppShell
        header={<Topbar />}
        rail={<SidebarNav />}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chat" element={<ForgeChat />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/pack/:kind/:id" element={<PackView />} />
          <Route path="/playground" element={<Playground />} />
          <Route path="/identity" element={<Identity />} />
          <Route path="/compose" element={<Compose />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/channels" element={<Channels />} />
          <Route path="/schema" element={<Schema />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppShell>
      <MobileBottomNav />
      <CalmOverlay />
    </BrowserRouter>
  )
}
